import React from "react";
import {useTranslation} from "@i18n/client";
import {I18nNamespace} from "@i18n";
import Icon from "@components/Icon";

const SelectButton = () => {
  const i18n = useTranslation(I18nNamespace.WEB_SCHEDULING);
  return (
    <div className="flex items-center">
      <div
        className={
          "hidden sm:block border border-solid box-border flex justify-center items-center text-center font-i cursor-pointer border-white text-sm leading-8 font-semibold px-[20px] py-[10px] rounded-4xl leading-8 border-white sm:group-hover:border-gray-1000 bg-gray-800/10 sm:group-hover:bg-gray-1000 text-gray-1000 sm:group-hover:text-white"
        }
      >
        {i18n.t("Select")}
      </div>
      <Icon icon={"arrRight"} className="inline sm:hidden text-gray-800 text-lg" />
    </div>
  );
};

export default React.memo(SelectButton);
